import React, { useState } from 'react';
import { ClipboardList, Menu, X } from 'lucide-react';
import { LandingContent } from './LandingContent';
import { AuthForm } from './AuthForm';
import { Footer } from './Footer';
import { HelpButton } from './HelpButton';
import { useTranslation } from '../lib/LanguageContext';

export function LandingPage() {
  const [showAuthForm, setShowAuthForm] = useState(false);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const { t } = useTranslation();

  const handleLoginClick = () => {
    setShowAuthForm(true);
  };

  const handleCloseAuth = () => {
    setShowAuthForm(false);
  };

  const toggleMobileMenu = () => {
    setMobileMenuOpen(!mobileMenuOpen);
  };

  // If auth form is shown, display only the auth form with close button
  if (showAuthForm) {
    return <AuthForm onClose={handleCloseAuth} showCloseButton={true} />;
  }

  return (
    <div className="min-h-screen relative">
      {/* Calm base background — animated elements live only inside the hero */}
      <div className="absolute inset-0 bg-gradient-to-b from-indigo-50 via-white to-white"></div>

      {/* Content */}
      <div className="relative z-10 flex flex-col min-h-screen">
        <div className="bg-white/50 backdrop-blur-sm shadow-xl flex-1 flex flex-col">
          {/* Header */}
          <div className="bg-indigo-600/95 backdrop-blur-sm px-4 md:px-6 py-3 md:py-4 flex-shrink-0 sticky top-0 z-30 shadow-sm">
            <div className="flex flex-col lg:flex-row lg:items-center lg:justify-between">
              {/* Logo and hamburger for mobile */}
              <div className="flex items-center justify-between">
                <div className="flex items-center space-x-2">
                  <ClipboardList className="h-6 w-6 text-indigo-100" />
                  <h1 className="text-xl md:text-2xl font-bold text-white">Simple Stickers</h1>
                </div>
                <button 
                  className="lg:hidden text-indigo-100 hover:text-white focus:outline-none" 
                  onClick={toggleMobileMenu}
                >
                  {mobileMenuOpen ? (
                    <X className="h-6 w-6" />
                  ) : (
                    <Menu className="h-6 w-6" />
                  )}
                </button>
              </div>
              
              {/* Navigation items */}
              <div className={`${
                mobileMenuOpen ? 'flex' : 'hidden'
              } lg:flex flex-col lg:flex-row lg:items-center mt-4 lg:mt-0 space-y-3 lg:space-y-0 lg:space-x-4`}>
                <a
                  href="#pricing"
                  onClick={() => setMobileMenuOpen(false)}
                  className="text-indigo-100 hover:text-white text-sm font-medium transition-colors"
                >
                  {t('navPricing')}
                </a>
                <a
                  href="#faq"
                  onClick={() => setMobileMenuOpen(false)}
                  className="text-indigo-100 hover:text-white text-sm font-medium transition-colors"
                >
                  {t('navFaq')}
                </a>

                {/* Action buttons */}
                <div className="flex items-center space-x-3 md:space-x-4">
                  {/* Help button - now functional */}
                  <HelpButton className="text-indigo-100 hover:text-white focus:outline-none" />

                  {/* Login button */}
                  <button
                    onClick={handleLoginClick}
                    className="bg-indigo-700 hover:bg-indigo-600 text-white px-4 py-2 rounded-lg text-sm font-medium transition-colors duration-200"
                  >
                    {t('signIn')}
                  </button>
                </div>
              </div>
            </div>
          </div>

          {/* Main Content */}
          <LandingContent onLoginClick={handleLoginClick} />
        </div>

        {/* Footer */}
        <Footer />
      </div>
    </div>
  );
}